import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Utility } from './utils/utils';

import { GDPRManager } from './../app/managers/gdpr.manager';
import { GDPRService } from './../app/shared/gdpr.service';
import { SharedService } from './shared/shared.service';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';
import { AuthenticationComponent } from './containers/authentication/authentication.component';
import { HomeComponent } from './containers/home/home.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { ErrorComponent } from './containers/error/error.component';
import { StatusComponent } from './containers/status/status.component';
import { OptInComponent } from './containers/opt-in/optIn.component';
import { CustomScreenComponent } from './containers/custom-screen/custom-screen.component';
import { PolicyComponent } from './containers/policy/policy.component';
import { LoaderComponent } from './components/loader';
import { ButtonComponent } from './components/button';
import { SnackBarComponent } from './components/snackbar';
import { InputComponent } from './components/input';


@NgModule({
  declarations: [
    AppComponent,
    AuthenticationComponent,
    HomeComponent,
    UserInfoComponent,
    ErrorComponent,
    StatusComponent,
    OptInComponent,
    NavbarComponent,
    CustomScreenComponent,
    PolicyComponent,
    LoaderComponent,
    ButtonComponent,
    SnackBarComponent,
    InputComponent
  ],
  imports: [
    BrowserModule,
    SharedModule.forRoot(),
    RouterModule.forRoot(appRoutes),
    ReCaptchaModule
  ],
  providers: [GDPRManager, GDPRService, SharedService, Utility],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts